import React from "react-native";
import { useTheme } from "../../theme";
import { TooltipIcon } from "./tooltip-icon";
import { IconProps } from "../icon";

export function TooltipWarningIcon({
    size,
    title,
    style,
}: {
    title: string;
    size?: IconProps["size"];
    style?: IconProps["style"];
}) {
    const theme = useTheme();
    return (
        <TooltipIcon
            icon="warning"
            color={theme.colors.warning}
            title={title}
            style={style}
            size={size}
        />
    );
}
